module.exports = __webpack_public_path__ + "e79e2b7afebbd6dbc4413efaf9193ad8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/_common/BeerCard/images/staff-favourite.png
// module id = KcRb
// module chunks = 0